module.exports = __webpack_public_path__ + "static/media/load.6ea9eacb.svg";